import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  gap: 0,
  marginBottom: 30,
  padding: 20,
  backgroundColor: theme.palette.fly.cardBg,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
  borderRadius: 8,
  position: "relative",
  overflow: "hidden",

  [theme.down("sm")]: {
    flexDirection: "column",
    gap: 0,
    padding: 15,
  },
}));
